export default __webpack_public_path__ + "static/media/icon-attach.a58cbe89.svg";